/**
 * return map
 */
const mapSearchAndReplace = () => {

    const map = [
        {search: "[bold]", replace: "<strong>"},
        {search: "[/bold]", replace: "</strong>"}
    ]
    return map;

}

export default mapSearchAndReplace;
